export default {
  callingAPI: false,
  searching: '',
  baseURL : 'http://localhost/',
  serverURI: 'http://localhost',
  user: null,
  token: null,
  userInfo: {},
  productList: [],
  gender :{
    "Male": 1,
    "Female": 2,
},
  userRoles  :{
    "Admin": 11,
    "Office Staff": 12,
},
userroleAdmin: 11,
userroleOfficeStaff: 12,
gender_male:1,
gender_female:2
}
